<template>
  <job-preview-content-data-outline
    :update-date="environment.updateDate"
    class="mt20 p20 tc"
  >
    <job-preview-right-column
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      comment-class="environment"
      :comment-highlights="commentHighlights"
      v-on="$listeners"
    />
    <div class="data-area pt20">
      <job-preview-content-pie-data
        :target-id="`${targetIdMap.environment.woman}${targetIdMap.environment.job.suffix}`"
        title="女性社員の割合"
        title-class="mt5"
        :value="environment.womanRate"
        data-test="woman"
        v-on="$listeners"
      />
      <job-preview-content-bar-data
        :target-id="`${targetIdMap.environment.overtime}${targetIdMap.environment.job.suffix}`"
        title="残業時間（平均）"
        title-class="mt5"
        :value="environment.overtime"
        :average-value="average.environment.overtime"
        unit="時間"
        data-test="overtime"
        v-on="$listeners"
      />
      <job-preview-content-bar-data
        :target-id="`${targetIdMap.environment.pto}${targetIdMap.environment.job.suffix}`"
        title="有給取得率"
        title-class="mt5"
        :value="environment.ptoRate"
        :average-value="average.environment.pto"
        unit="%"
        data-test="pto"
        v-on="$listeners"
      />
    </div>
    <p class="tc mr15">
      {{ companyName }}
    </p>
    <p class="tc mr15">
      の働く環境についてもっと知りたい方はこちら
    </p>
    <p class="btn-style-02 mt10">
      <a
        target="_blank"
        :style="`background: url(${userCommonImageUrlForPc}/icn_arrow_05.png) no-repeat 8px center;`"
      >
        <span class="pl10">データをすべて見る</span>
      </a>
    </p>
  </job-preview-content-data-outline>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewContentDataOutline from '@/components/atoms/JobPreviewContentDataOutline'
import JobPreviewRightColumn from '@/components/molecules/JobPreviewRightColumn'
import JobPreviewContentPieData from '@/components/atoms/JobPreviewContentPieData'
import JobPreviewContentBarData from '@/components/atoms/JobPreviewContentBarData'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewHighlight from '@/lib/jobPreviewHighlight'

export default {
  components: {
    JobPreviewContentDataOutline,
    JobPreviewRightColumn,
    JobPreviewContentPieData,
    JobPreviewContentBarData
  },
  mixins: [jobPreviewCommon, jobPreviewHighlight],
  props: {
    companyName: {
      type: String,
      required: true
    },
    environment: {
      type: Object,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      required: true
    },
    textCountMode: {
      type: Boolean,
      default: false
    }
  }
}
</script>
